'use client';
import React, { useState, useEffect } from 'react';
import Header from '@/components/Header';
import FooterSection from '@/components/FooterSection';
import TeamSection from '@/components/TeamSection';
import CookieConsent from '@/components/CookieConsent';
import { Language } from '@/lib/i18n';
import { useMergedTranslations } from '@/lib/useMergedTranslations';

interface TeamMember {
    id: number;
    name: string;
    position: string;
    description: string;
    image: string;
}

const STORAGE_KEY = 'ditib_language';

export default function Team() {
    const [language, setLanguage] = useState<Language>('de');
    const t = useMergedTranslations(language);

    useEffect(() => {
        // Restore language preference from localStorage
        const savedLang = localStorage.getItem(STORAGE_KEY);
        if (savedLang && ['de', 'tr', 'en', 'ar'].includes(savedLang)) {
            setLanguage(savedLang as Language);
        }
    }, []);

    const handleSetLanguage = (lang: Language) => {
        setLanguage(lang);
        localStorage.setItem(STORAGE_KEY, lang);
    };

    useEffect(() => {
        // Handle scroll from URL parameter (e.g., /team?scroll=team-section)
        const params = new URLSearchParams(window.location.search);
        const scrollTo = params.get('scroll');
        if (scrollTo) {
            setTimeout(() => {
                const el = document.getElementById(scrollTo);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, []);

    return (
        <main data-component-id="src\app\team\page.tsx:50:8" data-component-path="src\app\team\page.tsx" data-component-line="50" data-component-end-line="63" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22font-opensans%22%7D" className="font-opensans">
            <Header data-component-id="src\app\team\page.tsx:51:12" data-component-path="src\app\team\page.tsx" data-component-line="51" data-component-end-line="51" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" t={t} language={language} setLanguage={handleSetLanguage} />

            {/* Spacer for fixed header */}
            <div data-component-id="src\app\team\page.tsx:54:12" data-component-path="src\app\team\page.tsx" data-component-line="54" data-component-end-line="54" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-16%20md%3Ah-20%22%7D" className="h-16 md:h-20"></div>

            {/* Team Section */}
            <div data-component-id="src\app\team\page.tsx:57:12" data-component-path="src\app\team\page.tsx" data-component-line="57" data-component-end-line="59" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22team-section%22%7D" id="team-section">
                <TeamSection data-component-id="src\app\team\page.tsx:58:16" data-component-path="src\app\team\page.tsx" data-component-line="58" data-component-end-line="58" data-component-file="page.tsx" data-component-name="TeamSection" data-component-content="%7B%22elementName%22%3A%22TeamSection%22%7D" t={t} language={language} />
            </div>

            <FooterSection data-component-id="src\app\team\page.tsx:61:12" data-component-path="src\app\team\page.tsx" data-component-line="61" data-component-end-line="61" data-component-file="page.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" t={t} language={language} />
            <CookieConsent data-component-id="src\app\team\page.tsx:62:12" data-component-path="src\app\team\page.tsx" data-component-line="62" data-component-end-line="62" data-component-file="page.tsx" data-component-name="CookieConsent" data-component-content="%7B%22elementName%22%3A%22CookieConsent%22%7D" t={t} language={language} />
        </main>
    );
}
